import { useEffect, useMemo, useState } from 'preact/hooks'
import { WishlistStorage } from 'snippets/wishlist/wishlist-storage'
/**
 * Wishlist for offline use
 */
export default function useOfflineWishlist() {
  const storage = useMemo(() => {
    const wl = new WishlistStorage()
    return !wl ? null : wl
  }, [])

  const [wishlist, setWishlist] = useState(() => {
    if (!storage) return []
    return storage.getItems()
  })

  useEffect(() => {
    if (GM_STATE?.customer?.logged) return

    // If there are items in the wishlist, set the icon to filled
    const hasItems = wishlist.length > 0
    document.querySelectorAll('.header-heart-icon use').forEach((icon) => {
      icon.setAttribute('href', hasItems ? '#heart-filled' : '#heart')
    })
  }, [wishlist])

  /**
   *
   */
  const updateWishlistState = () => {
    setWishlist(() => {
      if (!storage) return []
      const items = storage.getItems()
      return [...items]
    })
  }

  /**
   *
   * @param {*} item
   */
  const setWishlistItem = (item) => {
    if (!storage) return
    storage.setItem(item)
    updateWishlistState()
  }

  /**
   *
   * @param {*} item
   */
  const removeWishlistItem = (item) => {
    if (!storage) return
    storage.removeItem(item)
    updateWishlistState()
  }

  /**
   *
   * @param {\} item
   * @returns
   */
  const hasItem = (item) => {
    if (!storage) return false
    return !!wishlist.find((i) => i === item)
  }

  const toggleItem = (item) => {
    if (hasItem(item)) {
      removeWishlistItem(item)
      return
    }
    setWishlistItem(item)
  }

  const getKeys = () => {
    const productIds = wishlist.reduce((acc, item) => {
      const [productId, _] = item.split(':')
      if (!productId) {
        return acc
      }
      acc[productId] = 1
      return acc
    }, {})

    return Object.keys(productIds)
  }

  const removeItemByParent = (product) => {
    if (!storage) return false
    const removeAllChildren = wishlist.filter((ws) => {
      const [id, _] = ws.split(':')
      return id === product
    })
    for (const child of removeAllChildren) {
      storage.removeItem(child)
    }
    updateWishlistState()
  }

  return { wishlist, hasItem, setWishlistItem, removeWishlistItem, getKeys, toggleItem, removeItemByParent }
}
